import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import EuroIcon from "@mui/icons-material/Euro";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import BusinessIcon from "@mui/icons-material/Business";
import BoltIcon from "@mui/icons-material/Bolt";
import { locationsCol } from "../../../../firebase.config";
import { getDocs } from "@firebase/firestore";
import { Location } from "../../../interfaces";
import {
  CoOwnerForm,
  ReceiptForm,
  LocationForm,
  SupplierForm,
  ExpenseForm,
} from "./";

const DataEntry = () => {
  const [tab, setTab] = useState(0);
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    async function fetchLocation() {
      const data = await getDocs(locationsCol);

      const results = data.docs.map((doc) => ({
        ...doc.data(),
      }));

      setLocations(results);
    }

    fetchLocation();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          maxWidth: "620px",
          margin: "0 auto",
          paddingTop: "1rem",
        }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable auto tabs example"
        >
          <Tab icon={<ReceiptLongIcon />} label="Uplatnice" />
          <Tab icon={<EuroIcon />} label="Troškovi" />
          <Tab icon={<PersonPinIcon />} label="Suvlasnici" />
          <Tab icon={<BusinessIcon />} label="Objekti" />
          <Tab icon={<BoltIcon />} label="Dobavljači" />
        </Tabs>
      </Box>
      <TabPanel
        children={<ReceiptForm locations={locations} />}
        value={tab}
        index={0}
      />
      <TabPanel value={tab} index={1}>
        <ExpenseForm locations={locations} />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <CoOwnerForm locations={locations} />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <LocationForm />
      </TabPanel>
      <TabPanel value={tab} index={4}>
        <SupplierForm />
      </TabPanel>
    </>
  );
};

export default DataEntry;

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
